'use strict';

// @start Collection Filters
var pathName = window.location.pathname;

function isoInit() {

  var filterArr = [];
  var activeFilter;

  // $("body").click
  //   (
  //     function(e)
  //     {
  //       if(e.target.className !== "collection-filter--collection-ul" || e.target.className !== 'collection-filter--subfilter-ul' || e.target.className !== 'collection-filter-link')
  //       {
  //         $(".collection-filter--collection-ul").removeClass('active');
  //       }
  //     }
  //   );


  $(document).on('click', '.collection-filter--subfilter-trigger', function (e) {
    e.preventDefault();

    var dropdown = $(this).next();

    if ($(dropdown).hasClass('hide-on-mobile')) {
      $(dropdown).removeClass('hide-on-mobile');
      $(dropdown).slideDown();
    } else {
      // $('.collection-filter--collection-ul').removeClass('hide-on-mobile');
      $(dropdown).hide();

      $(dropdown).addClass('hide-on-mobile');
    }
  });

  $(document).on('click', '.collection-filter-link', function (e) {

    // OLD
    return;

    var filter = $(this).attr('data-filter');
    var collection = $(this).attr('data-collection');
    var collectionHandle = $(this).attr('data-collection-handle');
    var tagHandle = $(this).attr('data-tag-handle');
    var pathString = '/collections/' + collection;
    var index;

    var previousSelection = $('.links-' + collection + '-' + tagHandle);
    var previousSelectionFilter = $(previousSelection).attr('data-filter');

    var filterStr = '';
    var url = '/collections/' + collectionHandle;

    e.preventDefault();

    $(previousSelection).removeClass('active');
    index = filterArr.indexOf(previousSelectionFilter);
    // filterArr.splice(index, 1);

    if (filterArr.includes(filter)) {
      $(this).removeClass('active');
      index = filterArr.indexOf(filter);
      filterArr.splice(index, 1);
    } else {
      $(this).addClass('active');
      filterArr.push(filter);
    }

    filterArr.forEach(function (item, i) {
      if (i == 0) {
        filterStr += item;
      } else {
        filterStr += "+" + item;
      }
    });

    url += '/' + filterStr;

    window.location.href = url;
  });

  $(document).on('click', '.collection-filter--dropdown-trigger', function (e) {

    if ($(window).width() <= 1200) {
      e.preventDefault();
      //  console.log('here');
      var next = $(this).next();
      $(next).slideToggle();
    }
  });

  $(document).on('click', '.apply-link', function (e) {
    e.preventDefault();
    var handle = $(this).attr('data-handle');
    var filterStr = '';
    var url = '/collections/' + handle;

    filterArr.forEach(function (item, i) {
      if (i == 0) {
        filterStr += item;
      } else {
        filterStr += "+" + item;
      }
    });

    url += '/' + filterStr;

    window.location.href = window.location.origin + url;
  });

  function createFilterArray() {

    var pathString = '/collections/' + collectionHandle + '/';
    var searchStr = window.location.pathname + '/';

    if (searchStr != pathString) {
      searchStr = searchStr.replace(pathString, '');
      searchStr = searchStr.replace('/', '');
      searchStr = searchStr.split('+');

      filterArr = searchStr;
    }
  }

  createFilterArray();
}

// If we're on the collection page
if (pathName.indexOf('collection') !== -1) {
  isoInit();
}

// @end Collection Filters